import { render, staticRenderFns } from "./FormBaseSetting.vue?vue&type=template&id=c8505bec&scoped=true"
import script from "./FormBaseSetting.vue?vue&type=script&lang=js"
export * from "./FormBaseSetting.vue?vue&type=script&lang=js"
import style0 from "./FormBaseSetting.vue?vue&type=style&index=0&id=c8505bec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8505bec",
  null
  
)

export default component.exports